import { render, staticRenderFns } from "./PaperAgreementDetail.vue?vue&type=template&id=624491da&scoped=true&"
import script from "./PaperAgreementDetail.vue?vue&type=script&lang=js&"
export * from "./PaperAgreementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624491da",
  null
  
)

export default component.exports